"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byteStreamToFile = byteStreamToFile;
exports.cleanArray = cleanArray;
exports.debounce = debounce;
exports.deepClone = deepClone;
exports.downloadByUrl = downloadByUrl;
exports.downloadImagesAsZip = downloadImagesAsZip;
exports.formatTime = formatTime;
exports.generateUUID = generateUUID;
exports.getByteLen = getByteLen;
exports.getQueryObject = getQueryObject;
exports.getTime = getTime;
exports.html2Text = html2Text;
exports.isExternal = isExternal;
exports.limg = limg;
exports.objectMerge = objectMerge;
exports.param = param;
exports.param2Obj = param2Obj;
exports.parseTime = parseTime;
exports.pickerOptions = void 0;
exports.toggleClass = toggleClass;
exports.uniqueArr = uniqueArr;
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.match");
var _typeof2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.typed.uint8-array");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.replace");
var _jszip = _interopRequireDefault(require("jszip"));
var _fileSaver = require("file-saver");
var _elementUi = require("element-ui");
/**
 * Created by jiachenpan on 16/11/18.
 */

function generateUUID() {
  // return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}
function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if ((0, _typeof2.default)(time) === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}
function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

// 格式化时间
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
function getByteLen(val) {
  var len = 0;
  for (var i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  return Math.floor(len);
}
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}
function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}
function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}
function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}
function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if ((0, _typeof2.default)(target) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if ((0, _typeof2.default)(sourceProperty) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}
function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}
var pickerOptions = exports.pickerOptions = [{
  text: '今天',
  onClick: function onClick(picker) {
    var end = new Date();
    var start = new Date(new Date().toDateString());
    end.setTime(start.getTime());
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近一周',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近一个月',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近三个月',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
    picker.$emit('pick', [start, end]);
  }
}];
function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var _later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(_later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(_later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
function deepClone(source) {
  if (!source && (0, _typeof2.default)(source) !== 'object') {
    throw new Error('error arguments', 'shallowClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && (0, _typeof2.default)(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}
function uniqueArr(arr) {
  return Array.from(new Set(arr));
}
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
function limg(file, size, info) {
  if (file.size / 1024 > size) {
    _elementUi.Message.error("\u4E0D\u80FD\u8D85\u8FC7".concat(info || size + 'KB'));
    return false;
  }
  return true;
}

/**
 * @description: 路径文件下载
 * @param {String} fName 文件名
 * @param {String} url 文件路径
 * @return {Void} 
 */
function downloadByUrl(fName, url) {
  fetch(url, {
    method: 'get',
    heanders: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Origin': "https://malltest.theinniverse.com.cn"
    }
  }).then(function (res) {
    return res.blob();
  }).then(function (blob) {
    var link = document.createElement('a');
    link.style.display = 'none';
    link.download = "".concat(fName); // 设置下载属性 以及文件名
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    // 释放的 URL 对象以及移除 a 标签
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
  });
}
function downloadImagesAsZip(_x) {
  return _downloadImagesAsZip.apply(this, arguments);
}
function _downloadImagesAsZip() {
  _downloadImagesAsZip = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(imageUrls) {
    var zip, promises;
    return (0, _regenerator2.default)().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          zip = new _jszip.default();
          promises = imageUrls.map(/*#__PURE__*/function () {
            var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(url, index) {
              var response, blob, fileName, content, _t;
              return (0, _regenerator2.default)().w(function (_context) {
                while (1) switch (_context.p = _context.n) {
                  case 0:
                    _context.p = 0;
                    _context.n = 1;
                    return fetch(url);
                  case 1:
                    response = _context.v;
                    if (response.ok) {
                      _context.n = 2;
                      break;
                    }
                    throw new Error("Failed to fetch image ".concat(url));
                  case 2:
                    _context.n = 3;
                    return response.blob();
                  case 3:
                    blob = _context.v;
                    // 获取文件名（这里假设URL的最后一个部分是文件名）
                    fileName = url.split('/').pop(); // 添加到ZIP文件中
                    zip.file(fileName, blob);

                    // 如果所有图片都已处理完毕，则生成ZIP文件并触发下载
                    if (!(index === imageUrls.length - 1)) {
                      _context.n = 5;
                      break;
                    }
                    _context.n = 4;
                    return zip.generateAsync({
                      type: "blob"
                    });
                  case 4:
                    content = _context.v;
                    (0, _fileSaver.saveAs)(content, "images.zip");
                  case 5:
                    _context.n = 7;
                    break;
                  case 6:
                    _context.p = 6;
                    _t = _context.v;
                    console.error("Error processing image ".concat(url, ":"), _t);
                  case 7:
                    return _context.a(2);
                }
              }, _callee, null, [[0, 6]]);
            }));
            return function (_x2, _x3) {
              return _ref.apply(this, arguments);
            };
          }()); // 等待所有图片处理完成
          _context2.n = 1;
          return Promise.all(promises);
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _downloadImagesAsZip.apply(this, arguments);
}
function byteStreamToFile(byteStream, fileName) {
  var blob = new Blob([byteStream], {
    type: 'application/zip,charset=utf-8'
  }); //此处必须添加
  var url = window.URL.createObjectURL(blob);
  var link = window.document.createElement('a'); // 创建a标签
  link.href = url;
  link.download = fileName; // 重命名文件
  link.click();
  URL.revokeObjectURL(url); // 释放内存
}

// 示例调用
// const images = [
//   'https://example.com/image1.jpg',
//   'https://example.com/image2.png',

// ];
// downloadImagesAsZip(images);